<template>
  <b-modal id="addEditDashboardModal"
           :no-close-on-backdrop="true"
           ref="modal"
           title-tag="h4"
           :title="modalTitle"
           ok-title="ОК"
           cancel-title="Отмена"
           modal-class="inmodal"
           footer-class="p-2"
           @ok="modalOk"
           @show="modalShow"
           @shown="modalShown">
    <template v-slot:modal-header="{ cancel }">
      <h4 class="modal-title">{{modalTitle}}</h4>
      <b-button variant="primary" style="margin-left: auto;"
                class="modal-close"
                v-on:click="cancel()"
                title="Закрыть">
        <i class="fa fa-close"></i>
      </b-button>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="primary" :disabled="isBusy" @click="ok()">
        <b-spinner small v-show="isBusy" class="mr-1"></b-spinner>
        <span>Сохранить</span>
      </b-button>
      <b-button variant="secondary" @click="cancel()">Отмена</b-button>
    </template>
    <form ref="form" @submit.stop.prevent="modalHandleSubmit" v-if="value">
      <b-form-row>
        <b-col md="12">
          <b-form-group label="Наименование рабочего стола" label-for="name">
            <b-form-input id="name"
                          ref="focusName"
                          v-model="value.name"
                          :class="{ error: validationErrors.Name }"
                          @change="validationErrors.Name = null"
                          trim></b-form-input>
            <ValidationField v-bind:errors="validationErrors.Name" />
          </b-form-group>
        </b-col>
      </b-form-row>
    </form>
  </b-modal>
</template>

<script>
import MnemoService from "@/services/mnemo.service";
import ValidationField from "@/components/ValidationField.vue";

export default {
  name: "AddEditDashboardModalComponent",
  components: {
    ValidationField,
  },
  data() {
    return {
      isBusy: false,
      validationErrors: [],      
    };
  },
  props: ["value"],
  methods: {
    modalShow(){
      this.isBusy = false;
      this.validationErrors = [];
    },
    modalShown(e) {
      this.$refs.focusName.focus();      
    },
    modalOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.isBusy = true;
      this.modalHandleSubmit();
    },
    modalHandleSubmit() {
      this.validationErrors = [];
      MnemoService.saveDashboard(this.value)
        .then((response) => {
          if (!this.value.id) {
            this.$emit("addDashboard", response.data);
          } else {
            this.$emit("editDashboard", this.value);
          }
          this.$nextTick(() => {
            this.$refs.modal.hide();
          });
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.validationErrors = error.response.data.errors;
          }
        })
        .finally(() => (this.isBusy = false));
    },
  },
  computed: {
    modalTitle: function () {
      return this.value && this.value.id
        ? "Редактирование рабочего стола"
        : "Добавление рабочего стола";
    },
  },
};
</script>